// hillEmissariesCarouselData.js
import bd7 from '../Assets/Brands/Weoutside/wedes1.png'
import bd8 from '../Assets/Brands/Weoutside/wedes2.png'
import bd9 from '../Assets/Brands/Weoutside/wedes3.png'
import bd10 from '../Assets/Brands/Weoutside/wedes4.png'
import bd11 from '../Assets/Brands/Weoutside/wedes5.png'
import bd4 from '../Assets/Brands/Weoutside/wedes6.png'
import bd1 from '../Assets/Brands/Weoutside/wedes7.png'
import bd2 from '../Assets/Brands/Weoutside/wedes8.png'

export const weoutsideCarouselData = [
  { imgUrl: bd11, title: 'Mockup 1' },
  { imgUrl: bd7, title: 'Mockup 2' },
  { imgUrl: bd4, title: 'Mockup 3' },
  { imgUrl: bd8, title: 'Mockup 1' },
  { imgUrl: bd1, title: 'Mockup 1' },
  { imgUrl: bd2, title: 'Mockup 2' },

  { imgUrl: bd9, title: 'Mockup 3' },

  { imgUrl: bd10, title: 'Mockup 2' },
]
